import { render, staticRenderFns } from "./PlaceOfResidenceModal.vue?vue&type=template&id=50dcd08f"
import script from "./PlaceOfResidenceModal.vue?vue&type=script&lang=js"
export * from "./PlaceOfResidenceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports